
  document.addEventListener('DOMContentLoaded', function() {
      document.addEventListener('click', (e) => {
        let link = e.target.closest('.faq__answer a');
        if (link) {
          e.preventDefault();
          e.stopPropagation();
          window.location.assign(link.href);
          return;
        }
      });
  });